/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 4/7/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageEditorToolbarController',
    function (_, $scope, PackageUtilService, ModalService, PermissionsService, $q, PackageActionService,
              PackageMediaService) {
        var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
        var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
        var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
        var TIMINGS_TAB_VIEW_STATE = 'PACKAGE_TIMINGS_VIEW_STATE';
        var BATCH_CLONE_STATE = 'PACKAGE_BATCH_CLONE_VIEW_STATE';
        var CLONE_STATE = 'PACKAGE_CLONE_VIEW_STATE';
        var PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE = 'PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE';
        var self = this;
        var saveCalled = false;

        self.toolbarPerms = {
            cloneRead: false,
            cloneWrite: false,
            collaboratorsWrite: false,
            mediaWrite: false,
            metaWrite: false,
            timingsWrite: false
        };

        var getPermissions = function () {
            var cloneReadPromise = PermissionsService.canRead(CLONE_STATE);
            var batchCloneReadPromise = PermissionsService.canRead(BATCH_CLONE_STATE);
            var cloneWritePromise = PermissionsService.canWrite(CLONE_STATE);
            var batchCloneWritePromise = PermissionsService.canWrite(BATCH_CLONE_STATE);
            var collaboratorsWritePromise = PermissionsService.canWrite(COLLABORATORS_TAB_VIEW_STATE);
            var mediaWritePromise = PermissionsService.canWrite(MEDIA_TAB_VIEW_STATE);
            var metaWritePromise = PermissionsService.canWrite(META_TAB_VIEW_STATE);
            var timingsWritePromise = PermissionsService.canWrite(TIMINGS_TAB_VIEW_STATE);
            var distroAdHocAddPartnersPromise = PermissionsService.canWrite(PACKAGE_AD_HOC_ADD_PARTNERS_VIEW_STATE);

            $q.all({cloneRead: cloneReadPromise,
                    cloneWrite: cloneWritePromise,
                    batchCloneRead: batchCloneReadPromise,
                    batchCloneWrite: batchCloneWritePromise,
                    collaboratorsWrite: collaboratorsWritePromise,
                    mediaWrite: mediaWritePromise,
                    metaWrite: metaWritePromise,
                    timingsWrite: timingsWritePromise,
                    adHocWrite: distroAdHocAddPartnersPromise}).then(function(perms) {
                self.toolbarPerms.cloneRead = perms.cloneRead || perms.batchCloneRead;
                self.toolbarPerms.cloneWrite = perms.cloneWrite || perms.batchCloneWrite;
                self.toolbarPerms.collaboratorsWrite = perms.collaboratorsWrite;
                self.toolbarPerms.mediaWrite = perms.mediaWrite;
                self.toolbarPerms.metaWrite = perms.metaWrite;
                self.toolbarPerms.timingsWrite = perms.timingsWrite;
                self.toolbarPerms.adHocWrite = perms.adHocWrite;
            });
        };

        self.editorForm = PackageUtilService.editorForm;
        self.actions = PackageActionService.editorActions;

        var showLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: true});
        };

        var hideLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: false});
        };

        self.handleSelectedAction = function () {
            PackageActionService.handleSelectedAction(
                self.selectedAction,
                showLoadingIndicator,
                hideLoadingIndicator
            );
            self.selectedAction = null;
        };

        self.saveDisabled = function () {
            if (self.editorForm.$pristine) {
                return true;
            }

            if (self.editorForm.$name === '$ctrl.packageMediaEditorForm') {
                return self.editorForm.$invalid || saveCalled || PackageMediaService.hasSaveConflict();
            } else {
                return (self.editorForm.$name !== '$ctrl.packageMetadataEditorForm' && self.editorForm.$invalid) || saveCalled;
            }
        };

        self.saveClickHandler = function () {
            if (!self.saveDisabled() && self.saveHandler) {
                saveCalled = true;
                self.saveHandler().then(function () {
                    saveCalled = false;
                });
            }
        };

        self.newClickHandler = function () {
            if (self.statusAllowsEdit() && !self.contextData.locked && !self.contextData.isDelivering) {
                self.newHandler();
            }
        };

        self.deleteClickHandler = function () {
            if (self.statusAllowsEdit() && !self.contextData.locked && !self.contextData.isDelivering) {
                self.deleteHandler();
            }
        };

        self.addDisabledClickHandler = function () {
            self.addDisabledHandler();
        };

        self.revertDisabled = function () {
            return self.editorForm.$pristine;
        };

        self.revertClickHandler = function () {
            if (!self.revertDisabled() && self.revertHandler) {
                self.revertHandler();
            }
        };

        self.closeClickHandler = function () {
            if (PackageUtilService.postCloseUpdate) {
                PackageUtilService.postCloseUpdate();
            }
            if (self.closeHandler) {
                self.closeHandler();
            }
        };

        self.prevPageDisabled = function () {
            return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === 1 && self.pagingOptions.currentPageItemIndex === 0 : true;
        };

        self.prevPageClickHandler = function () {
            if (!self.prevPageDisabled() && self.prevHandler) {
                self.prevHandler();
            }
        };

        self.nextPageDisabled = function () {
            return (self.pagingOptions.pageData.length) ? self.pagingOptions.currentPage === self.pagingOptions.totalPages &&
            self.pagingOptions.currentPageItemIndex === self.pagingOptions.pageSize : true;
        };

        self.nextPageClickHandler = function () {
            if (!self.nextPageDisabled() && self.nextHandler) {
                self.nextHandler();
            }
        };

        self.uploadClickHandler = function () {
            if (self.statusAllowsEdit() && !self.contextData.locked &&
                    !self.contextData.isDelivering && self.uploadHandler) {
                self.uploadHandler();
            }
        };

        self.confirmClone = function () {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to clone ' + self.contextData.name + '?',
                pullCancelLeft: true,
                title: 'Clone ' + self.contextData.name + '?',
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, self.packageCloneClickHandler);
        };
        self.tabAddDisabledInvalid = function () {
            return PackageUtilService.tabAddDisabledInvalid();
        };

        self.tabDeleteInvalid = function () {
            return PackageUtilService.tabDeleteInvalid();
        };

        self.packageCloneClickHandler = function () {
            if (self.cloneHandler) {
                self.cloneHandler();
            }
        };

        self.statusAllowsEdit = function () {
            return PackageUtilService.statusAllowsEdit(self.contextData.status);
        };

        self.canChangeAutoDelivery = function () {
            return self.contextData && self.contextData.content && self.contextData.content.type !== 'Ad/PreRoll' &&
                    !self.contextData.locked &&
                PackageUtilService.statusAllowsAutoDeliveryCheckbox(self.contextData.status);
        };

        self.addAdHocSubscription = function () {
            PackageUtilService.tabAdHocPartnerFunction();
        };

        self.showHoldForComponentsCB = function () {
            return _.invoke(PackageUtilService, 'showHoldForComponentsCB') || false;
        };

        self.adHocButtonVisible = function () {
            return !!(self.toolbarPerms.adHocWrite &&
                self.statusAllowsEdit() &&
                self.contextData.category &&
                self.contextData.content.type !== 'Ad/PreRoll' &&
                (self.contextData.content.type === 'Movie/Special' || self.contextData.season || self.contextData.volume));
        };

        self.actionDropdownDisabled = function () {
            return !self.saveDisabled() || (self.contextData && self.contextData.locked);
        };

        self.wasMainVideoUploaded = () => {
            return PackageMediaService.isAnUploadPath();
        };

        $scope.$watch(function () {
            return PackageUtilService.editorForm;
        }, function () {
            self.editorForm = PackageUtilService.editorForm;
        });

        getPermissions();
    });
